import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useErrorHandler } from "../../../common/hooks";
import useObservedExpression from "../../Hooks/useObservedExpression";
import { InputFieldModel } from "../../Models/InputFieldModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const InputFieldComponent: React.FC<IComponentProps<InputFieldModel>> = ({ component, context }) => {
  const errorHandler = useErrorHandler();

  const [value, setValue] = useState<string>("");
  const [valueResult] = useObservedExpression<string>(component.Value, context, "InputFieldComponent");

  useEffect(() => {
    if (valueResult !== value) {
      setValue(valueResult ?? "");
    }
  }, [valueResult]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);

    // Update the context variable if Value expression is provided
    if (component.Value) {
      try {
        context.Evaluator.assign(component.Value, context, newValue);
      } catch (error) {
        errorHandler(error);
      }
    }
  };

  const componentLayoutSx = getComponentLayout(component);

  const fieldName = component.Name ?? component.Label.replace(/\s+/g, "");

  return (
    <TextField
      name={fieldName}
      label={component.Label}
      value={value}
      onChange={handleChange}
      placeholder={component.Placeholder}
      required={component.IsRequired}
      multiline={component.IsMultiLine}
      fullWidth
      variant="standard"
      sx={componentLayoutSx}
    />
  );
};

export default InputFieldComponent;
